export default state => state.selectedAnnotations;
